/**
 * 课程标准 api
 * 课程标准api
 *
 * OpenAPI spec version: 0.2.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import ApiClient from '../../ApiClient';
import CourseStandardCreateForm from '../../course_standard/model/CourseStandardCreateForm';
import CourseStandardEditForm from '../../course_standard/model/CourseStandardEditForm';
import CourseStandardMoveForm from '../../course_standard/model/CourseStandardMoveForm';
import CourseStandardVo from '../../course_standard/model/CourseStandardVo';
import CreatedVo from '../../course_standard/model/CreatedVo';
import KnowledgeCreateForm from '../../course_standard/model/KnowledgeCreateForm';
import KnowledgeEditForm from '../../course_standard/model/KnowledgeEditForm';
import KnowledgeMapVo from '../../course_standard/model/KnowledgeMapVo';
import UpdatedVo from '../../course_standard/model/UpdatedVo';
  /**
   * CourseStandard service.
   * @module course_standard/api/CourseStandardApi
   * @version 0.2.0
   */

  /**
   * Constructs a new CourseStandardApi. 
   * @alias module:course_standard/api/CourseStandardApi
   * @class
   * @param {module:ApiClient} apiClient Optional API client implementation to use,
   * default to {@link module:ApiClient#instance} if unspecified.
   */
  var exports = function(apiClient) {
    this.apiClient = apiClient || ApiClient.instance;



    /**
     * 新增课程标准
     * @param {module:course_standard/model/CourseStandardCreateForm} body 请求参数body
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:course_standard/model/CreatedVo}
     */
this.addCourseStandard = function(body) {
      var postBody = body;

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling addCourseStandard";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var isPublic = false;

      var authNames = [];
      var contentTypes = [];
      var accepts = [];
      var returnType = CreatedVo;
      return this.apiClient.callApi(
        '/api/course_standard/', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType,isPublic
      );
    }


    /**
     * 新增知识点
     * @param {Integer} courseStandardId 课程标准id
     * @param {module:course_standard/model/KnowledgeCreateForm} body 请求参数body
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:course_standard/model/CreatedVo}
     */
this.addKnowledge = function(courseStandardId, body) {
      var postBody = body;

      // verify the required parameter 'courseStandardId' is set
      if (courseStandardId == undefined || courseStandardId == null) {
        throw "Missing the required parameter 'courseStandardId' when calling addKnowledge";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling addKnowledge";
      }


      var pathParams = {
        'courseStandardId': courseStandardId
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var isPublic = false;

      var authNames = [];
      var contentTypes = [];
      var accepts = [];
      var returnType = CreatedVo;
      return this.apiClient.callApi(
        '/api/course_standard/{courseStandardId}/knowledge', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType,isPublic
      );
    }


    /**
     * 修改知识点基本信息
     * @param {Integer} courseStandardId 课程标准id
     * @param {Integer} knowledgeId 知识点id
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:course_standard/model/UpdatedVo}
     */
this.deleteKnowledge = function(courseStandardId, knowledgeId) {
      var postBody = null;

      // verify the required parameter 'courseStandardId' is set
      if (courseStandardId == undefined || courseStandardId == null) {
        throw "Missing the required parameter 'courseStandardId' when calling deleteKnowledge";
      }

      // verify the required parameter 'knowledgeId' is set
      if (knowledgeId == undefined || knowledgeId == null) {
        throw "Missing the required parameter 'knowledgeId' when calling deleteKnowledge";
      }


      var pathParams = {
        'courseStandardId': courseStandardId,
        'knowledgeId': knowledgeId
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var isPublic = false;

      var authNames = [];
      var contentTypes = [];
      var accepts = [];
      var returnType = UpdatedVo;
      return this.apiClient.callApi(
        '/api/course_standard/{courseStandardId}/knowledge/{knowledgeId}', 'DELETE',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType,isPublic
      );
    }


    /**
     * 移动知识点位置
     * @param {Integer} courseStandardId 课程标准id
     * @param {Integer} currentKnowledgeId 当前拖拽knowledge id
     * @param {Integer} targetKnowledgeId 目标knowledge id
     * @param {String} whereInsert 插入的位置 bottom、center、top
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:course_standard/model/UpdatedVo}
     */
this.dragKnowledge = function(courseStandardId, currentKnowledgeId, targetKnowledgeId, whereInsert) {
      var postBody = null;

      // verify the required parameter 'courseStandardId' is set
      if (courseStandardId == undefined || courseStandardId == null) {
        throw "Missing the required parameter 'courseStandardId' when calling dragKnowledge";
      }

      // verify the required parameter 'currentKnowledgeId' is set
      if (currentKnowledgeId == undefined || currentKnowledgeId == null) {
        throw "Missing the required parameter 'currentKnowledgeId' when calling dragKnowledge";
      }

      // verify the required parameter 'targetKnowledgeId' is set
      if (targetKnowledgeId == undefined || targetKnowledgeId == null) {
        throw "Missing the required parameter 'targetKnowledgeId' when calling dragKnowledge";
      }

      // verify the required parameter 'whereInsert' is set
      if (whereInsert == undefined || whereInsert == null) {
        throw "Missing the required parameter 'whereInsert' when calling dragKnowledge";
      }


      var pathParams = {
        'courseStandardId': courseStandardId
      };
      var queryParams = {
        'currentKnowledgeId': currentKnowledgeId,
        'targetKnowledgeId': targetKnowledgeId,
        'whereInsert': whereInsert
      };
      var headerParams = {
      };
      var formParams = {
      };

      var isPublic = false;

      var authNames = [];
      var contentTypes = [];
      var accepts = [];
      var returnType = UpdatedVo;
      return this.apiClient.callApi(
        '/api/course_standard/{courseStandardId}/knowledge/drag', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType,isPublic
      );
    }


    /**
     * 编辑课程知识地图（如果知识地图id和课程标准的id不同，将克隆整个地图）
     * @param {Integer} courseStandardId 课程标准id
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:course_standard/model/KnowledgeMapVo}
     */
this.editKnowledgeMap = function(courseStandardId) {
      var postBody = null;

      // verify the required parameter 'courseStandardId' is set
      if (courseStandardId == undefined || courseStandardId == null) {
        throw "Missing the required parameter 'courseStandardId' when calling editKnowledgeMap";
      }


      var pathParams = {
        'courseStandardId': courseStandardId
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var isPublic = false;

      var authNames = [];
      var contentTypes = [];
      var accepts = [];
      var returnType = KnowledgeMapVo;
      return this.apiClient.callApi(
        '/api/course_standard/{courseStandardId}/knowledge_map/edit', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType,isPublic
      );
    }


    /**
     * 获取课程标准详情
     * @param {Integer} id 课程标准id
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:course_standard/model/CourseStandardVo}
     */
this.getCourseStandardDetail = function(id) {
      var postBody = null;

      // verify the required parameter 'id' is set
      if (id == undefined || id == null) {
        throw "Missing the required parameter 'id' when calling getCourseStandardDetail";
      }


      var pathParams = {
        'id': id
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var isPublic = false;

      var authNames = [];
      var contentTypes = [];
      var accepts = [];
      var returnType = CourseStandardVo;
      return this.apiClient.callApi(
        '/api/course_standard/{id}', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType,isPublic
      );
    }


    /**
     * 课程标准列表
     * @param {Object} opts Optional parameters
     * @param {Integer} opts.courseId 课程id
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Array.<module:course_standard/model/CourseStandardVo>}
     */
this.getCourseStandardListByCourseId = function(opts) {
      opts = opts || {};
      var postBody = null;


      var pathParams = {
      };
      var queryParams = {
        'courseId': opts['courseId']
      };
      var headerParams = {
      };
      var formParams = {
      };

      var isPublic = false;

      var authNames = [];
      var contentTypes = [];
      var accepts = [];
      var returnType = [CourseStandardVo];
      return this.apiClient.callApi(
        '/api/course_standard/', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType,isPublic
      );
    }


    /**
     * 课程标准列表
     * @param {Object} opts Optional parameters
     * @param {Integer} opts.textBookId 课程id
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Array.<module:course_standard/model/CourseStandardVo>}
     */
this.getCourseStandardListByTextbookId = function(opts) {
      opts = opts || {};
      var postBody = null;


      var pathParams = {
      };
      var queryParams = {
        'textBookId': opts['textBookId']
      };
      var headerParams = {
      };
      var formParams = {
      };

      var isPublic = false;

      var authNames = [];
      var contentTypes = [];
      var accepts = [];
      var returnType = [CourseStandardVo];
      return this.apiClient.callApi(
        '/api/course_standard/by_textbook', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType,isPublic
      );
    }


    /**
     * 获取课程知识地图
     * @param {Integer} courseStandardId 课程标准id，必填
     * @param {Object} opts Optional parameters
     * @param {Integer} opts.drillType 题型
     * @param {Integer} opts.companyId 上传院校id
     * @param {Integer} opts.accountId 上传者id
     * @param {String} opts.text 检索词 选填
     * @param {Boolean} opts.recurseCount 直接知识点的碎片练习数是否累加到所有上级知识点
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:course_standard/model/KnowledgeMapVo}
     */
this.getKnowledgeMap = function(courseStandardId, opts) {
      opts = opts || {};
      var postBody = null;

      // verify the required parameter 'courseStandardId' is set
      if (courseStandardId == undefined || courseStandardId == null) {
        throw "Missing the required parameter 'courseStandardId' when calling getKnowledgeMap";
      }


      var pathParams = {
        'courseStandardId': courseStandardId
      };
      var queryParams = {
        'drillType': opts['drillType'],
        'companyId': opts['companyId'],
        'accountId': opts['accountId'],
        'text': opts['text'],
        'recurseCount': opts['recurseCount']
      };
      var headerParams = {
      };
      var formParams = {
      };

      var isPublic = false;

      var authNames = [];
      var contentTypes = [];
      var accepts = [];
      var returnType = KnowledgeMapVo;
      return this.apiClient.callApi(
        '/api/course_standard/{courseStandardId}/knowledge_map', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType,isPublic
      );
    }


    /**
     * 修改课程标准信息
     * @param {Integer} id 课程标准id
     * @param {module:course_standard/model/CourseStandardMoveForm} body 请求参数body
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:course_standard/model/UpdatedVo}
     */
this.move = function(id, body) {
      var postBody = body;

      // verify the required parameter 'id' is set
      if (id == undefined || id == null) {
        throw "Missing the required parameter 'id' when calling move";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling move";
      }


      var pathParams = {
        'id': id
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var isPublic = false;

      var authNames = [];
      var contentTypes = [];
      var accepts = [];
      var returnType = UpdatedVo;
      return this.apiClient.callApi(
        '/api/course_standard/{id}/move', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType,isPublic
      );
    }


    /**
     * 设置课程是否为精品课程
     * @param {Integer} id 课程标准id
     * @param {Integer} awarded 是否精品课程 0普通 1精品
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:course_standard/model/UpdatedVo}
     */
this.setAwarded = function(id, awarded) {
      var postBody = null;

      // verify the required parameter 'id' is set
      if (id == undefined || id == null) {
        throw "Missing the required parameter 'id' when calling setAwarded";
      }

      // verify the required parameter 'awarded' is set
      if (awarded == undefined || awarded == null) {
        throw "Missing the required parameter 'awarded' when calling setAwarded";
      }


      var pathParams = {
        'id': id
      };
      var queryParams = {
        'awarded': awarded
      };
      var headerParams = {
      };
      var formParams = {
      };

      var isPublic = false;

      var authNames = [];
      var contentTypes = [];
      var accepts = [];
      var returnType = UpdatedVo;
      return this.apiClient.callApi(
        '/api/course_standard/{id}/awarded', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType,isPublic
      );
    }


    /**
     * 修改课程标准信息
     * @param {Integer} id 课程标准id
     * @param {module:course_standard/model/CourseStandardEditForm} body 请求参数body
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:course_standard/model/UpdatedVo}
     */
this.updateCourseStandard = function(id, body) {
      var postBody = body;

      // verify the required parameter 'id' is set
      if (id == undefined || id == null) {
        throw "Missing the required parameter 'id' when calling updateCourseStandard";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling updateCourseStandard";
      }


      var pathParams = {
        'id': id
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var isPublic = false;

      var authNames = [];
      var contentTypes = [];
      var accepts = [];
      var returnType = UpdatedVo;
      return this.apiClient.callApi(
        '/api/course_standard/{id}', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType,isPublic
      );
    }


    /**
     * 修改知识点基本信息
     * @param {Integer} courseStandardId 课程标准id
     * @param {Integer} knowledgeId 知识点id
     * @param {module:course_standard/model/KnowledgeEditForm} body 请求参数body
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:course_standard/model/UpdatedVo}
     */
this.updateKnowledge = function(courseStandardId, knowledgeId, body) {
      var postBody = body;

      // verify the required parameter 'courseStandardId' is set
      if (courseStandardId == undefined || courseStandardId == null) {
        throw "Missing the required parameter 'courseStandardId' when calling updateKnowledge";
      }

      // verify the required parameter 'knowledgeId' is set
      if (knowledgeId == undefined || knowledgeId == null) {
        throw "Missing the required parameter 'knowledgeId' when calling updateKnowledge";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling updateKnowledge";
      }


      var pathParams = {
        'courseStandardId': courseStandardId,
        'knowledgeId': knowledgeId
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var isPublic = false;

      var authNames = [];
      var contentTypes = [];
      var accepts = [];
      var returnType = UpdatedVo;
      return this.apiClient.callApi(
        '/api/course_standard/{courseStandardId}/knowledge/{knowledgeId}', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType,isPublic
      );
    }
  };

  export default exports;
